export interface AuthRequestModel {
  userId: string;
  authId: string;
}

export interface AuthStateModel {
  auth: AuthModel;
  loading: boolean;
  error: any | null;
}

export enum OTP_MEANS {
  APP = 'App',
  EMAIL = 'Email',
  NONE = 'None',
PASSKEY = 'Passkey'
}

export interface AuthModel {
  token: string | null;
  refreshToken: string | null;
  id: string | null,
  email: string | null,
  role: string | null,
  user: UserModel | null,
}

export interface UserModel {
  office: string,
  _id: string,
  email: string,
  phone: string,
  avatar: string,
  firstName: string,
  lastName: string,
  gender: string,
  dateOfBirth: Date,
  legalStatus: string,
  countryOfBirth: string,
  motherTongue: string,
  streetAdress: string,
  unitNumber: number,
  country: string,
  state: string,
  city: string,
  zipCode: string,
  emergencyName: string,
  emergencyRelationship: string,
  emergencyPhone: string,
  emergencyEmail: string,
  univer: string,
  degreeProgrammArea: string,
  degreeAchived: string,
  educationCountry: string,
  practiceLang: string,
  yearsOfPractice: string,
  educationLang: string,
  role: string,
  staffType: string,
  status: string,
  learnerNumber: string,
  learnerType: string,
  uploadDate: Date,
  isCanContact: boolean,
  accountStatus: string,
  accountType: string,
  authId: string,
  isStaff: boolean,
  updatedAt: Date,
  examType: string,
  id: string,
  learningId: string,
  learningProgramId: string,
  sponsored: string,
  createdAt: Date,
  cnoNumber: string,
  cnoDate: Date,
}


export interface LearnerUserModel {
  id: string,
  firstName: string,
  lastName: string,
  email: string,
  avatar: string,
  applicationNo: string,
  programNo: string,
  examType: string,
  status: string,
  familyMedicine: boolean,
  associatedMedicalSchool: string,
  postgraduateTrainingProgram: string,
  PGYLevel: string,
  PEAPStartDate: Date,
  PEAPEndDate: Date,
  imgBursaryAcknowledgement: boolean,
  imgBursaryVoidCheque?: string,
  imgBursarySocialInsuranceNumber: string,
  adminAssigned?: string
}
